const PUBLIC_CONTENT_PREFIXES = ['/brokers', '/compare', '/guides'] as const;

export function isPublicContentCrossZonePath(pathname: string): boolean {
  return PUBLIC_CONTENT_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}
